var _style, _path, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMechanicalControlCam({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.4,2.8C2.6,3,0.5,5.2,0.6,7.9c-0.1,2.8,2.1,5.1,4.9,5.2c2.8-0.1,5-2.4,4.9-5.2H5.5L5.4,2.8z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10.3,
    y1: 7.9,
    x2: 11.5,
    y2: 7.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.4,
    y1: 7.9,
    x2: 13.5,
    y2: 7.9
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.4,
    y1: 7.9,
    x2: 15.6,
    y2: 7.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMechanicalControlCam);
export default __webpack_public_path__ + "static/media/MechanicalControlCam.ee9048dd9ae97e45aa41363eb2ee1d93.svg";
export { ForwardRef as ReactComponent };